package com.schoolconnect.app.feature.schoolusers.edit

import com.schoolconnect.app.feature.schoolusers.SchoolUserRoleUi
import com.schoolconnect.app.feature.schoolusers.SchoolUserRowUi
import com.schoolconnect.app.feature.schoolusers.SchoolUserStatusUi
import com.schoolconnect.app.feature.schoolusers.add.AddSchoolUserSchoolOption
import com.schoolconnect.app.feature.schoolusers.add.addSchoolUserRoles
import com.schoolconnect.app.feature.schoolusers.add.addSchoolUserSchools
import com.schoolconnect.app.feature.schoolusers.add.addSchoolUserStatuses
import com.schoolconnect.app.feature.schoolusers.schoolUserGenderDisplayLabel

data class EditSchoolUserFormValues(
    val staffId: String = "",
    val fullName: String = "",
    val staffRole: String = "",
    val mobileNumber: String = "",
    val emailAddress: String = "",
    val schoolName: String = "",
    val schoolId: String = "",
    val role: String = "",
    val gender: String = "",
    val status: String = "Active"
)

data class EditSchoolUserValidationErrors(
    val fullName: String = "",
    val staffId: String = "",
    val staffRole: String = "",
    val mobileNumber: String = "",
    val emailAddress: String = "",
    val schoolId: String = "",
    val role: String = "",
    val gender: String = "",
    val status: String = ""
) {
    val hasAnyError: Boolean
        get() = listOf(
            staffId,
            fullName,
            staffRole,
            mobileNumber,
            emailAddress,
            schoolId,
            role,
            gender,
            status
        ).any { it.isNotBlank() }
}

internal val editSchoolUserSchools: List<AddSchoolUserSchoolOption> = addSchoolUserSchools
internal val editSchoolUserRoles: List<String> = addSchoolUserRoles
internal val editSchoolUserStatuses: List<String> = addSchoolUserStatuses

internal fun editSchoolUserFormValuesFrom(user: SchoolUserRowUi): EditSchoolUserFormValues {
    val role = when (user.role) {
        SchoolUserRoleUi.SCHOOL_ADMIN -> "School Admin"
        SchoolUserRoleUi.SCHOOL_MANAGEMENT -> "School Management"
    }
    val status = when (user.status) {
        SchoolUserStatusUi.ACTIVE -> "Active"
        SchoolUserStatusUi.INACTIVE -> "Inactive"
    }

    return EditSchoolUserFormValues(
        staffId = user.staffId,
        fullName = user.name,
        staffRole = user.staffRole,
        mobileNumber = user.mobile,
        emailAddress = user.email,
        schoolName = user.school,
        schoolId = user.schoolId.ifBlank {
            editSchoolUserSchools.firstOrNull { it.name == user.school }?.id.orEmpty()
        },
        role = role,
        gender = schoolUserGenderDisplayLabel(user.gender),
        status = status
    )
}
